export function toHex(value: string) {
  let result = BigInt(value).toString(16);

  if (result.length % 2) {
    result = '0' + result;
  }

  return `0x${result}`;
}
